<script setup>
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3'
import CustomNodeEditMenu from '@/components/wysiwyg-components/nodes/CustomNodeEditMenu.vue'
import IncidentDisplay from '@/components/incidents/IncidentDisplay.vue'

const props = defineProps(nodeViewProps)
const incidentId = props.node.attrs.incidentId
</script>

<template>
  <node-view-wrapper
    as="div"
    class="d-inline-block"
  >
    <CustomNodeEditMenu
      :variant-parameters="{ incidentId }"
      current-variant="incident-card"
      :variants="[
        { tag: 'inline-incident', label: 'Inline', icon: 'mdi-text' },
        { tag: 'incident-card', label: 'Card', icon: 'mdi-card-text' },
      ]"
      :node-props="props"
    >
      <template #element="nodeProps">
        <IncidentDisplay
          :incident-id="incidentId"
          v-bind="nodeProps"
        />
      </template>
    </CustomNodeEditMenu>
  </node-view-wrapper>
</template>

<style scoped></style>
